import { mapActions, mapGetters } from "vuex"
import Raven from "raven-js"
import * as urlUtil from "../../common/utils/url.js"
import localStorage from "../../common/utils/localStorage"

let configs = window.__midasStaticConfig_wzry_tuan_config

export default {
  computed: {
    ...mapGetters([
      "userAgent",
      "loginState",
      "gameInfoConfigs",
      "selectedZone",
      "selectedRole",
      "partitionInfo",
      "tuanProductConfig",
      "activityProductConfig",
      "minJoinTuanNum",
      "subscribeStatus"
    ])
  },
  methods: {
    ...mapActions([
      "openDialog",
      "getGroupBuyings",
      "openGroupBuying",
      "reportUserAction",
      "reportAndJump",
      "placeOrder",
      "midasPay",
      "setOnShareHandler",
      "getMyGroup",
      "setLoadingStart",
      "setLoadingEnd",
      "setToastMsg",
      "setShareDialogStatus",
      "goToStorePage"
    ]),
    handleOrderFilterInfo({ orderRes, tuanId, isTuanOwner }) {
      // "" ：表示可以购买
      // 2310：表示已经拥有这个物品
      // 2311：没有对应英雄
      // 2311，2310：没有对应英雄并且有这个物品
      if (tuanId && orderRes.filter_info && orderRes.filter_info[this.tuanProductConfig.productId]) {
        if (orderRes.filter_info[this.tuanProductConfig.productId].indexOf("2310") > -1) {
          // 用户已拥有该物品
          this.openDialog({
            dialogContent: "<p class='text'>您已拥有该物品！</p>",
            confirmText: "确认"
          })
          this.reportUserAction({
            iformat: configs.REPORT.PAGEVIEW.POPUP_HAVE
          })
        } else if (orderRes.filter_info[this.tuanProductConfig.productId].indexOf("2311") > -1) {
          // 用户没有皮肤对应的英雄
          this.openDialog({
            dialogContent: "<p class='text'>您现在还未拥有该英雄，先拥有英雄后才可以体验皮肤哦！</p>",
            confirmText: "继续购买",
            onConfirm: () => {
              this.midasPayGoods({
                orderRes: orderRes,
                tuanId: tuanId || "",
                isTuanOwner
              })
            },
            cancelText: "取消"
          })
          this.reportUserAction({
            iformat: configs.REPORT.PAGEVIEW.POPUP_NO_HERO
          })
        }
      } else if (!tuanId && orderRes.filter_info && orderRes.filter_info[this.activityProductConfig.productId]) {
        if (orderRes.filter_info[this.activityProductConfig.productId].indexOf("2310") > -1) {
          // 用户已拥有该物品
          this.openDialog({
            dialogContent: "<p class='text'>您已拥有该物品！</p>",
            confirmText: "确认"
          })
          this.reportUserAction({
            iformat: configs.REPORT.PAGEVIEW.POPUP_HAVE
          })
        } else if (orderRes.filter_info[this.activityProductConfig.productId].indexOf("2311") > -1) {
          // 用户没有皮肤对应的英雄
          this.openDialog({
            dialogContent: "<p class='text'>您现在还未拥有该英雄，先拥有英雄后才可以体验皮肤哦！</p>",
            confirmText: "继续购买",
            onConfirm: () => {
              this.midasPayGoods({
                orderRes: orderRes,
                tuanId: tuanId || "",
                isTuanOwner
              })
            },
            cancelText: "取消"
          })
          this.reportUserAction({
            iformat: configs.REPORT.PAGEVIEW.POPUP_NO_HERO
          })
        }
      } else {
        this.midasPayGoods({
          orderRes: orderRes,
          tuanId: tuanId || "",
          isTuanOwner
        })
      }
    },

    openTuanPrompt() {
      // 参数校验
      if (!this.orderPreCheck()) return

      this.setLoadingStart()
      this.canSubmit = false

      this.getMyGroup()
        .then(res => {
          this.setLoadingEnd()
          this.canSubmit = true

          let selfTuanId = this.getSelfTuanId({ tuanRes: res, zoneId: this.selectedZone.zone_id, allStatus: false, noOff: true })

          if (selfTuanId) {
            // 有自己的团，则拦截开团
            this.openDialog({
              dialogContent: "<p class='text'>您在当前大区已经参与“廉颇-无尽征程”的团购活动，不能再开团了哦~</p>",
              confirmText: "去看我的团",
              onConfirm: () => {
                this.goToSelfTuanItem(selfTuanId)
              }
            })
            this.reportUserAction({
              iformat: configs.REPORT.PAGEVIEW.POPUP_JOINED_TUAN
            })
            return
          }

          this.openDialog({
            dialogContent: `<p class='text'>确认消耗 <span class="text_32" style="font-weight: 800;">${this.tuanProductConfig.price /
              10}点券${this.userAgent.iOS ? "" : "/￥" + this.tuanProductConfig.price / 100}</span> 购买${
              this.tuanProductConfig.productName
            }并发起团购吗？礼包内含：廉颇·无尽征程+30荣耀积分。</p><p class='text'>${
              this.minJoinTuanNum
            }人即可拼团成功，成团后道具将发放到<span>${
              this.selectedZone.zone_name
            } </span> 游戏内部邮箱中哦，请及时领取，拼团不成功将原路全额退款。</p><p class='text'>一旦开团，不能退团，24小时后如果未成团，团自动解散。</p>`,
            confirmText: "确认",
            onConfirm: this.openGroup
          })

          this.reportUserAction({
            iformat: configs.REPORT.PAGEVIEW.POPUP_PAY_CONFIRM
          })

          this.reportUserAction({
            iformat: configs.REPORT.CLICK.OPEN_GROUP,
            resultInfo: {
              page: this.$route.path && this.$route.path.indexOf("group-detail") > -1 ? "detail" : "index"
            }
          })
        })
        .catch(error => {
          this.setLoadingEnd()
          this.canSubmit = true

          if (error && error.ret == 1414) {
            this.setToastMsg("您来晚了，活动已结束！")
          } else {
            this.setToastMsg(error && error.msg ? error.msg : "系统繁忙，请稍后再试")
          }
        })
    },

    openGroup() {
      this.setLoadingStart()
      this.canSubmit = false

      this.openGroupBuying()
        .then(groupRes => {
          return this.placeOrder({
            zoneid: this.selectedZone.zone_id,
            productId: this.tuanProductConfig.productId,
            productNum: 1,
            productName: this.tuanProductConfig.productName,
            gameId: [this.partitionInfo.area, "", "", this.partitionInfo.partition].join("_"),
            orderExtend: {
              is_tuan: 1
            }
          }).then(res => {
            this.setLoadingEnd()
            this.canSubmit = true

            this.handleOrderFilterInfo({
              orderRes: res,
              tuanId: groupRes.tuan_id,
              isTuanOwner: true
            })
          })
        })
        .catch(error => {
          this.setLoadingEnd()
          this.canSubmit = true

          if (error && error.ret == 1414) {
            this.setToastMsg("您来晚了，活动已结束！")
          } else {
            this.setToastMsg(error && error.msg ? error.msg : "系统繁忙，请稍后再试")
          }
        })
    },

    clickDirectPay() {
      this.reportUserAction({
        iformat: configs.REPORT.CLICK.DIRECT_PAY,
        resultInfo: {
          page: this.$route.path && this.$route.path.indexOf("group-detail") > -1 ? "detail" : "index"
        }
      })

      if (!this.orderPreCheck()) return

      this.setLoadingStart()
      this.canSubmit = false

      this.getMyGroup()
        .then(res => {
          this.setLoadingEnd()
          this.canSubmit = true

          let selfTuanId = this.getSelfTuanId({ tuanRes: res, zoneId: this.selectedZone.zone_id, allStatus: false, noOff: true })

          if (selfTuanId) {
            // 有自己的团，则拦截原价购买
            this.openDialog({
              dialogContent: "<p class='text'>您在当前大区已经参与“廉颇-无尽征程”的团购活动，不能再单人秒杀了哦~</p>",
              confirmText: "去看我的团",
              onConfirm: () => {
                this.goToSelfTuanItem(selfTuanId)
              }
            })
            this.reportUserAction({
              iformat: configs.REPORT.PAGEVIEW.POPUP_DIRECT_PAY_FORBID
            })
          } else {
            this.openDialog({
              dialogContent: `<p class='text'>参与其他召唤师的团，<span class="text_32" style="font-weight: 800;">60点券${
                this.userAgent.iOS ? "" : "/￥6"
              }</span> 秒杀【荣耀征程礼包】，得廉颇新皮肤再加30荣耀积分</p><p class='text'>请在游戏内邮箱中查收~</p>`,
              confirmText: "继续单人秒杀",
              cancelText: "参与礼包拼团",
              onConfirm: this.directPay,
              onCancel: this.goToStrangerGroup
            })
            this.reportUserAction({
              iformat: configs.REPORT.PAGEVIEW.POPUP_DIRECT_PAY_CONFIRM
            })
          }
        })
        .catch(error => {
          this.setLoadingEnd()
          this.canSubmit = true

          if (error && error.ret == 1414) {
            this.setToastMsg("您来晚了，活动已结束！")
          } else {
            this.setToastMsg(error && error.msg ? error.msg : "系统繁忙，请稍后再试")
          }
        })
    },

    directPay() {
      this.setLoadingStart()
      this.canSubmit = false

      return this.placeOrder({
        zoneid: this.selectedZone.zone_id,
        productId: this.activityProductConfig.productId,
        productNum: 1,
        productName: this.activityProductConfig.productName,
        gameId: [this.partitionInfo.area, "", "", this.partitionInfo.partition].join("_")
      })
        .then(res => {
          this.setLoadingEnd()
          this.canSubmit = true

          this.handleOrderFilterInfo({
            orderRes: res
          })
        })
        .catch(error => {
          this.setLoadingEnd()
          this.canSubmit = true

          this.setToastMsg(error && error.msg ? error.msg : "系统繁忙，请稍后再试")
        })
    },

    // 拉起支付
    midasPayGoods({ orderRes, tuanId, isTuanOwner }) {
      let midasParams = {
        token: orderRes.token,
        mid: orderRes.mid
      }
      if (tuanId) {
        midasParams.dc = "qqwallet,qdqb,qbqd" // 团购需要屏蔽Q币和QQ钱包支付渠道(只有微信支付渠道和点券支付渠道)
        midasParams.realPrice = this.tuanProductConfig.price
        midasParams.drmInfo = `tuan_group=${this.gameInfoConfigs.tuanConfig.activityNum}&version=3.0&tuan_id=${tuanId}${
          isTuanOwner ? "&delay_flag=1" : ""
        }`

        if (this.$route.params && this.$route.params.id && this.$route.params.id == tuanId) {
          // 在详情页参团，重新请求tuanInfo
          midasParams.onQueryResult = () => {
            this.getTuanInfo &&
              this.getTuanInfo().then(() => {
                if (this.isJoiner) {
                  // 参团成功
                  this.openDialog({
                    dialogContent: "<p class='text'>支付成功！</p><p class='text'>道具将发放到游戏邮箱哦~</p>",
                    confirmText: "确认"
                  })
                  this.reportUserAction({
                    iformat: configs.REPORT.PAGEVIEW.POPUP_JOIN_TUAN_OK
                  })
                } else {
                  this.setToastMsg("支付未完成")
                }
              })
          }
        } else {
          // 首页开团 或者 详情页开团，跳转到新的详情页
          midasParams.onQueryResult = () => {
            // 判断我的团已经有了刚刚的小团id才跳到详情页
            this.setLoadingStart()
            this.getMyGroup()
              .then(res => {
                this.setLoadingEnd()
                if (
                  res.tuan_info.tuan_mpinfo.tuan_info.some(
                    item => item.tuan_id == tuanId && item.tuan_status == "on" && item.if_joined == 1
                  )
                ) {
                  this.openTuanSuccessDialog()

                  this.$router.replace(`/group-detail/${tuanId}`)
                } else {
                  this.setToastMsg("支付未完成")
                }
              })
              .catch(error => {
                this.setLoadingEnd()
                this.setToastMsg(error && error.msg ? error.msg : "系统繁忙，请刷新重试")
              })
          }
        }
      } else {
        // 原价购买
        midasParams.realPrice = this.activityProductConfig.price
        midasParams.drmInfo = `group_id=${this.gameInfoConfigs.activityConfig.activityNum}`
      }

      if (this.userAgent.iOS) {
        midasParams.directChannel = "game_coin"
      }

      return this.midasPay(midasParams).then(() => {
        if (tuanId) {
          if (this.$route.params && this.$route.params.id && this.$route.params.id == tuanId) {
            // 参团成功
            this.openDialog({
              dialogContent: "<p class='text'>支付成功！</p><p class='text'>道具将发放到游戏邮箱哦~</p>",
              confirmText: "确认"
            })
            // 在详情页参团，重新请求tuanInfo
            this.getTuanInfo && this.getTuanInfo()

            this.reportUserAction({
              iformat: configs.REPORT.PAGEVIEW.POPUP_JOIN_TUAN_OK
            })
          } else {
            // 开团成功弹窗
            this.openTuanSuccessDialog()
            // 不是在当前详情页参团(首页开团或者详情页开团)，跳转到对应的团详情页
            this.$router.replace(`/group-detail/${tuanId}`)
          }
        } else {
          this.openDialog({
            dialogContent: "<p class='text'>支付成功！</p><p class='text'>道具将发放到游戏邮箱哦，请尽快领取~</p>",
            confirmText: "确认",
            cancelText: "回到游戏",
            onCancel: this.enterGame
          })

          this.setLocalBought({
            zoneId: this.selectedZone.zone_id,
            openid: this.loginState.openid,
            productId: this.activityProductConfig.productId
          })

          this.reportUserAction({
            iformat: configs.REPORT.PAGEVIEW.DIRECT_PAY_SUCCESS
          })
        }
      })
    },

    // 开团成功弹窗
    openTuanSuccessDialog() {
      // 根据是否已关注公众号，判断弹窗上是否有引导关注的按钮
      if (this.subscribeStatus === false) {
        this.openDialog({
          dialogContent:
            "<p class='text'>支付成功！成团后道具将发放到游戏邮箱哦~</p><p class='text'>两人即可成团，快邀请好友来一起参与吧~</p>",
          confirmText: "邀请好友参团",
          cancelText: "订阅成团信息",
          onConfirm: () => {
            this.setShareDialogStatus(true)
          },
          onCancel: () => {
            this.guideSubscribe()
          }
        })
      } else {
        this.openDialog({
          dialogContent:
            "<p class='text'>支付成功！成团后道具将发放到游戏邮箱哦~</p><p class='text'>两人即可成团，快邀请好友来一起参与吧~</p>",
          confirmText: "邀请好友参团",
          onConfirm: () => {
            this.setShareDialogStatus(true)
          }
        })
      }
      this.reportUserAction({
        iformat: configs.REPORT.PAGEVIEW.POPUP_JOIN_TUAN_OK
      })
    },

    orderPreCheck() {
      // 参数校验
      if (!this.tuanProductConfig) {
        this.setToastMsg("活动配置错误")
        return
      }
      // 参数校验
      if (!this.activityProductConfig) {
        this.setToastMsg("活动配置错误")
        return
      }
      if (!this.minJoinTuanNum) {
        this.setToastMsg("活动配置错误")
        return
      }
      if (!this.loginState) {
        this.setToastMsg("请先登录")
        return
      }
      if (!this.selectedZone || !this.selectedRole || !this.partitionInfo) {
        this.setToastMsg("请先选择大区角色")
        return
      }
      if (!this.canSubmit) {
        return
      }
      if (
        this.checkLocalBought({
          zoneId: this.selectedZone.zone_id,
          openid: this.loginState.openid,
          productId: this.activityProductConfig.productId
        })
      ) {
        // 用户已拥有该物品
        this.openDialog({
          dialogContent: "<p class='text'>您已拥有该物品！</p>",
          confirmText: "确认"
        })
        this.reportUserAction({
          iformat: configs.REPORT.PAGEVIEW.POPUP_HAVE
        })
        return
      }
      return true
    },

    goToStrangerGroup() {
      this.reportUserAction({
        iformat: configs.REPORT.CLICK.MORE_STRANGER_GROUP,
        resultInfo: {
          page: this.$route.path && this.$route.path.indexOf("group-detail") > -1 ? "detail" : "index"
        }
      })
      this.$router.push("/stranger")
    },

    goToSelfTuanItem(tuanId) {
      this.reportUserAction({
        iformat: configs.REPORT.CLICK.BACK_TO_SELF_TUAN_JOIN
      })
      if (!(this.$route.params && this.$route.params.id == tuanId)) {
        this.$router.push(`/group-detail/${tuanId}`)
      }
    },

    /**
     * 获取用户团列表中，当前大区有无 正在进行的/已成团/已结束 的团
     * tuanRes 团列表请求的返回结果
     * zoneId 大区
     * allStatus 小团所有状态，都会跳转到详情页
     */
    getSelfTuanId({ tuanRes, zoneId, allStatus, noOff }) {
      let selfTuanId = ""
      if (
        tuanRes.tuan_info &&
        tuanRes.tuan_info.tuan_mpinfo &&
        tuanRes.tuan_info.tuan_mpinfo.tuan_info &&
        tuanRes.tuan_info.tuan_mpinfo.tuan_info.length
      ) {
        // tuan_status: on-进行中；over-已成团（已结束）；off-已失效
        let currentTuan = tuanRes.tuan_info.tuan_mpinfo.tuan_info.find(tuanItem => {
          let tuanUserZoneId =
            tuanItem.cgi_data && urlUtil.getParam("zoneid", tuanItem.cgi_data) ? urlUtil.getParam("zoneid", tuanItem.cgi_data) : ""
          // 用户参团且(团进行中或者已成团)
          return (tuanItem.tuan_status === "on" || tuanItem.tuan_status === "over") && tuanItem.if_joined == 1 && zoneId == tuanUserZoneId
        })
        let currentOffTuan = tuanRes.tuan_info.tuan_mpinfo.tuan_info.find(tuanItem => {
          let tuanUserZoneId =
            tuanItem.cgi_data && urlUtil.getParam("zoneid", tuanItem.cgi_data) ? urlUtil.getParam("zoneid", tuanItem.cgi_data) : ""
          // 用户参团且团已结束
          return tuanItem.tuan_status === "off" && tuanItem.if_joined == 1 && zoneId == tuanUserZoneId
        })

        // 标识了不管off的团
        if (((this.$route.query && this.$route.query.noOff == 1) || noOff) && !allStatus) {
          if (currentTuan) selfTuanId = currentTuan.tuan_id
        } else {
          // 有正在进行中的团，优先跳转到正在进行中的团详情，没有的话则跳转到off的团详情
          if (currentTuan) {
            selfTuanId = currentTuan.tuan_id
          } else if (currentOffTuan) {
            selfTuanId = currentOffTuan.tuan_id
          }
        }
      }
      return selfTuanId
    },

    guideSubscribe() {
      if (!this.loginState) return
      let uaTxt = "微信或者手Q"
      let qrCodeLink = ""
      if (this.loginState.session_id == "hy_gameid" && this.loginState.session_type == "wc_actoken") {
        uaTxt = "微信"
        qrCodeLink = configs.GAME_INFO.wxCodeLink
      } else {
        uaTxt = "手Q"
        qrCodeLink = configs.GAME_INFO.qqCodeLink
      }
      this.openDialog({
        dialogContent: `<div class="subscribe_to_img"></div>
            <p class="currency_text">关注【腾讯充值】公众号</p>
            <p class="currency_text">可以及时收到成团提醒哦</p>
            <p class="currency_text">请长按或截图以下二维码，到${uaTxt}关注~</p>
            <div class="subscribe_to_code_img">
              <img src="${qrCodeLink}" alt="">
            </div>`,
        targetClassName: "alert_currency"
      })
      this.reportUserAction({
        iformat: configs.REPORT.PAGEVIEW.POPUP_GUIDE_SUBSCRIBE
      })
    },

    setLocalBought({ zoneId, openid, productId }) {
      if (zoneId && openid && productId) {
        let localBuyedPropKey = ["wzry_tuan_bought", openid, zoneId, productId].join("_")
        localStorage.set(localBuyedPropKey, "true")
      }
    },

    checkLocalBought({ zoneId, openid, productId }) {
      if (zoneId && openid && productId) {
        let localBuyedPropKey = ["wzry_tuan_bought", openid, zoneId, productId].join("_")
        return localStorage.get(localBuyedPropKey) ? true : false
      } else {
        return false
      }
    },

    // 去游戏
    enterGame() {
      if (this.userAgent.msdk) {
        window.msdkCloseWebview && window.msdkCloseWebview()
      } else {
        location.href = this.gameInfoConfigs.gameUrl
      }

      this.reportUserAction({
        iformat: configs.REPORT.CLICK.BACK_TO_GAME
      })
    },

    catchInitError(error) {
      if (error && error.ret == 1414) {
        this.openDialog({
          dialogContent: "<div class='subscribe_to_img'></div><p class='text'>活动已结束，下期更精彩哦~</p>",
          confirmText: "去游戏专区逛逛",
          onConfirm: () => {
            this.goToStorePage()
          },
          targetClassName: "alert_currency",
          hideClose: true
        })
      } else {
        this.openDialog({
          dialogContent: "<div class='subscribe_to_img'></div><p class='text'>活动太火爆，请刷新页面重新进入</p>",
          confirmText: "刷新页面",
          onConfirm: () => {
            let times = configs.GAME_INFO.waitTime || 3
            setTimeout(() => {
              location.reload()
            }, 1000 * times)

            for (let i = 0; i < times; i++) {
              setTimeout(() => {
                this.setLoadingStart(`${times - i}秒后将为您刷新页面，请稍等`)
              }, 1000 * i)
            }
          },
          targetClassName: "alert_currency",
          hideClose: true
        })
      }

      this.reportUserAction({
        iformat: configs.REPORT.PAGEVIEW.PAGE_ERROR,
        resultInfo: {
          ret: error && error.ret ? error.ret : -1
        }
      })

      Raven.captureException(new Error("wzry-tuan-init-error"), {
        tags: { type: "wzry-tuan-init-error" },
        extra: {
          error,
          getters: this.$store.getters,
          rootState: this.$store.state
        }
      })
    }
  }
}
